import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"
import {
  StyledBody,
  StyledHeaderH2,
  StyledLi,
  StyledLink,
  StyledSubtitle,
  StyledUl,
} from "../../reusable/wrappers/BodyText"
import CenterText from "../../reusable/wrappers/CenterText"
import ImageContainer from "../../reusable/wrappers/ImageContainer"

const StyledTextWrapp = styled.div`
  margin-top: 40px;
  max-width: 1400px;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-right: 150px;
    padding-left: 150px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 20px;
    padding-left: 20px;
  }
`
const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
  img {
    object-fit: fill !important;
  }
`

const PrivacyPolicyPage = () => {
  const isDesktop = useIsDesktop()
  const headerText = [
    `אתר מאזדה מופעל ומנוהל על ידי דלק מוטורס בע"מ ח.פ 510947153 שכתובתה ת.ד 200 ניר צבי 7290500`,
    `נתונים שתמסור ואשר יאספו אודותייך במסגרת שימושך בשירותים שמציע האתר, יישמרו במאגרי המידע הרשומים שלנו ויעובדו על ידינו בהתאם להוראות החוק ולפי הסכמתך. נציין בפניך כי לא חלה עליך כל חובה חוקית למסור את המידע ומסירתו תלויה ברצונך בעת גלישתך באתר ובעת מסירת פרטייך לצורך שימוש בשירותי האתר.`,
  ]
  return (
    <StyledPageWrapper $padding={"0px"}>
      <StyledPageDiv>
        <ImageContainer
          src={
            isDesktop
              ? "/img/PrivacyPolicy.jpg"
              : "/img/PrivacyPolicymobile.jpg"
          }
        />
        <BreadCrumbsWrapper name={"PrivacyPolicy"} />
        <StyledTextWrapp>
          <CenterText
            title="מדיניות הפרטיות באתר מאזדה"
            subtitle="במאזדה, הפרטיות שלך היא מעל הכול. לכן חשוב לנו לשקף לך את השימוש במידע שנאסף באתר.
            כאן אפשר להתעדכן בכל פרטי מדיניות הפרטיות שלנו:"
            headerText={headerText}
            footerText="*המדיניות מנוסחת בלשון זכר מטעמי נוחות אך מתייחסת לגברים ונשים כאחד"
            margin={true}
            withBorder
          />

          <StyledHeaderH2 $margin={40}>
            הסכמתך לתנאי השימוש ומדיניות הפרטיות
          </StyledHeaderH2>
          <StyledBody>
            השימוש באתר מעיד על הסכמתך למדיניות פרטיות זו, וכן לתנאי השימוש של
            האתר ובהתאם לכל דין אשר חל או יחול על שימוש סביר באתר. אם אינך מסכים
            לאחד מהתנאים, אנא הימנע מהמשך השימוש באתר ו/או פנה אלינו על-מנת
            שנוכל לסייע לך בדרכים חלופיות. שימוש במידע אודותייך ייעשה אך ורק
            בהתאם לחובות שבדין.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>איזה מידע אנחנו אוספים?</StyledHeaderH2>
          <StyledSubtitle $margin={10} $fontWeight={"300"}>
            מידע אישי
          </StyledSubtitle>
          <StyledBody>
            אנו מגבילים את בקשותינו לקבלת מידע אישי בסיסי בלבד, כגון:
          </StyledBody>
          <StyledUl $padding={20}>
            <StyledLi>שם מלא(פרטי ומשפחה)</StyledLi>
            <StyledLi>מספר טלפון</StyledLi>
            <StyledLi>כתובת דואר</StyledLi>
            <StyledLi>כתובת דואר אלקטרוני</StyledLi>
          </StyledUl>
          <StyledBody>
            אנו מגבילים את איסוף המידע האישי למידע שאנו מאמינים כמינימלי ביותר
            על מנת לספק לך את השירותים המוצעים באתר או באמצעותו.
          </StyledBody>

          <StyledSubtitle $margin={20} $fontWeight={"300"}>
            מידע אנונימי
          </StyledSubtitle>
          <StyledBody>
            בעת גלישתך באתר, נשמר אצלנו באופן אוטומטי מידע אנונימי מסוים, כגון
            שמו של ספק שירותי האינטרנט שלך, כתובת ה-IP שלך, תאריך ביקורך, משך
            הביקור, באילו עמודים ביקרת באתר וסוג הדפדפן בו נעשה שימוש.
          </StyledBody>

          <StyledSubtitle $margin={20} $fontWeight={"400"}>
            Cookies
          </StyledSubtitle>
          <StyledBody>
            {`  האתר עושה שימוש ב-"עוגיות/קוקיס" (Cookies), באמצעותן נאסף מידע
            אנונימי לצורך התפעול השוטף והתקין של האתר, לאימות פרטים, אבטחת מידע
            וכדי להתאים את האתר להעדפותיך האישיות וכך להקל על שימושך באתר. נוסף
            על כן, ייתכן שהמידע שייאסף באמצעות הקוקיס ישמש לצורך הצגת מודעות
            והצעות למוצרים ולשירותים שונים של החברה בעת ביקורך באתר ו/או באתרים
            אחרים.`}
          </StyledBody>
          <StyledBody>
            הקוקיס, Cookies, הן קבצי טקסט, שהדפדפן שלך יוצר בעת כניסתך לאתר
            מאזדה, בהנחה שהגדרות הדפדפן שלך מאפשרות זאת. חלק מהקוקיס יפקעו כאשר
            תסגור את הדפדפן וייתכן שאחרות יישמרו על גבי הכונן הקשיח. הקוקיס
            מכילות מידע מגוון כדוגמת הדפים שבהם ביקרת באתר, משך הזמן ששהית באתר,
            מהיכן הגעת אל האתר, ומדורים ומידע שהשתמשת בהם במסגרת השיטוט באתר.{" "}
            <br></br>
            כמו כן, לעיתים הקוקיס משמשות גם כדי לייתר את הצורך בהזנת פרטייך
            האישיים מחדש, אם והיכן שתתבקש לכך, בכל ביקור חוזר בעמודים הרלוונטים
            באתר שמחייבים רישום והזנת פרטים. <br></br>
            {` המידע שבקבצי הקוקיס מוצפן. דלק מוטורס בע"מ נוקטת צעדי זהירות כדי
            להבטיח שרק מחשבי החברה יוכלו לקרוא ולהבין את המידע האגור בהן.`}
            <br></br>
            אם אינך רוצה לקבל קוקיס, תוכל לחסום את האפשרות על ידי שינוי ההגדרות
            בדפדפן שלך. עם זאת, עלייך לדעת כי חסימת אפשרות זו עשויה לגרום לכך
            שלא תוכל ליהנות מחלק מהפונקציות והשירותים שבאתר או באתרים אחרים,
            בהתאם להגדרות הדפדפן.<br></br>
            {`כמו כן, בכל עת, באפשרותך למחוק את הקוקיס ממחשבך. מוצע לעשות כן אם
            אתה משוכנע שאינך רוצה שאתרי דלק מוטורס בע"מ והשירותים המוצעים בהם
            יותאמו להעדפותיך. הואיל והעוגיות לעיתים מקלות עלייך את הצורך להזין
            פרטים אישיים ונתוני זיהוי בכל ביקור מחדש באתר/ים, אזי יש להיזהר
            מלמחוק אותן, אלא אם דאגת לשמור את הפרטים המזהים הדרושים במקום ידוע
            ומאובטח.`}
          </StyledBody>

          <StyledSubtitle $margin={20} $fontWeight={"300"}>
            מידע אישי מזוהה
          </StyledSubtitle>
          <StyledBody>
            נתונים אישיים מזהים אודותיך יישמרו במאגרי החברה הרשומים על-פי חוק,
            אך ורק אם מסרת אותם מיוזמתך, ולפי הסכמתך באותן נסיבות, כגון הרשמה
            לאחד השירותים המוצעים באתר או כל פניה אחרת אלינו הכרוכה במסירת
            פרטייך לצורך מתן השירות. כל פרט שתמסור ישמר לפי הוראות קפדניות שבחוק
            ובכפוף להסכמה שתינתן על-ידך בסמוך למסירת המידע.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>היכן ישמר המידע?</StyledHeaderH2>
          <StyledBody>
            המידע שתמסור בעת שימושך באתר והשירותים המוצעים בו, יישמר במאגרי
            המידע הרשומים של החברה, שבין מטרותיהם ניהול וייעול השירות והקשר עם
            לקוחות החברה, חברות בנות ו/או חברות קשורות, לצרכים תפעוליים,
            שיווקיים, שמירת מידע חיוני ולצרכים סטטיסטיים, לרבות עיבוד המידע,
            דיוור ישיר ופניות לצורך מימוש מטרות אלו בכפוף להוראות הדין.
          </StyledBody>
          <StyledBody>
            אינך נדרש למסור מידע זה לפי חוק, אך אם תבחר שלא למסור מידע במקום בו
            הוא נחוץ לתפעול שירות המוצע באתר, ייתכן כי לא תוכל ליהנות מחלקים
            מהאתר ו/או משירותים אותם החברה מציעה בו.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>
            איזה שימוש נעשה במידע שנאסף?
          </StyledHeaderH2>
          <StyledBody>
            {`דלק מוטורס בע"מ או מי מטעמה, מחויבת לשמור על הסודיות ועל חשאיות
            המידע שברשותה ולציית להוראות החוק. ככל שייאסף מידע אודותייך בעת
            השימוש באתר או אם תמסור מידע לדלק מוטורס בע"מ מיוזמתך באמצעות
            השירותים המוצעים באתר, דלק מוטורס תשתמש במידע רק על פי מדיניות
            פרטיות זו או על פי הוראות כל דין, ולמטרות המנויות להלן:`}
          </StyledBody>
          <StyledBody $margin={20}>
            א. עיקר המידע שנאסף מעצם שימושך באתר הינו מידע סטטיסטי, אנונימי,
            שאינו מזהה אותך אישית, ונועד כדי להתאים את האתר ואת השירותים המוצעים
            בו להעדפותייך ולצרכייך.
          </StyledBody>
          <StyledBody $margin={20}>
            ב.הניהול התקין של האתר ותפעול השירותים המוצעים בו.
          </StyledBody>
          <StyledBody $margin={20}>
            ג.מתן שירות לקוחות וייעול ההתקשרות עם החברה.
          </StyledBody>
          <StyledBody $margin={20}>
            {" "}
            ד.ביצוע סקרים וסטטיסטיקות, ולצרכי שיווק – והכול בכפוף להסכמות
            שיתקבלו ממך לפי החוק, ולצרכים פנימיים של דלק מוטורס, ללא מסירתו
            למפרסמים חיצוניים.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>
            האם המידע מועבר לצדדים שלישיים?
          </StyledHeaderH2>
          <StyledBody>
            נוסף על האמור לעיל, דלק מוטורס לא תעביר את המידע אודותייך לצדדים
            שלישיים, אלא ככל שהדבר הותר במסגרת מדיניות פרטיות זו, על-פי חובה
            שבדין, ובמקרים הבאים:
          </StyledBody>
          <StyledBody $margin={20}>
            א. אם תרכוש מוצרים ושירותים מצדדים שלישיים באמצעות האתר, יועבר
            לצדדים אלה המידע הדרוש להם לשם השלמת התהליך ומתן השירות.
          </StyledBody>
          <StyledBody $margin={20}>
            ב. מחלוקת משפטית ו/או טענה ו/או תביעה בינך לבין דלק מוטורס, או אם
            תבצע באתר פעולות שבניגוד לדין.
          </StyledBody>
          <StyledBody $margin={20}>
            ג. על-פי צו שיפוטי או על-פי דרישת רשות מוסמכת על-פי חוק.
          </StyledBody>
          <StyledBody $margin={20}>
            ד. כדי למנוע פגיעה חמורה בך ו/או ברכושך או בגופו או רכושו של צד
            שלישי או בחברה.
          </StyledBody>
          <StyledBody $margin={20}>
            ה. במקרה של מיזוג תאגידי עם גוף אחר ו/או מיזוג פעילות האתר עם
            פעילותו של צד שלישי, ובלבד שמקבל המידע החדש יקבל על עצמו את הוראות
            מדיניות פרטיות זו, על כל מגבלותיה ותנאיה.
          </StyledBody>
          <StyledBody $margin={20}>
            ו. בכל מקום באתר בו תינתן על-ידך נסכמה מפורשת לכך.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>שירותים של צדדים שלישיים</StyledHeaderH2>
          <StyledBody>
            ייתכן שחלק מהשירותים ו/או מוצרים ו/או פרסומות המוצגים באתר, מנוהלים
            על ידי שותפי מסחר ותוכן של האתר. ככל שכך, שירותים אלה מוגשים באמצעות
            מחשביהם של אותם שותפים ולא ממחשבי דלק מוטורס. אם תשתמש בשירותים אלו,
            השימוש, לרבות מידע שעשוי להיאסף אודותייך עקב כך, כפוף למדיניות
            הפרטיות של מנהלי השירותים הללו ולא למדיניות הפרטיות של דלק מוטורס.
            בהתאם, מומלץ לעיין גם במסמכי מדיניות הפרטיות שלהם.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>חופש הבחירה ודיוור</StyledHeaderH2>
          <StyledBody>
            אנו מעוניינים לשלוח אליך מדי פעם מידע בדבר שירותיה ומוצריה של החברה.
            מידע כזה ישוגר אליך אך ורק אם נתת את הסכמתך לכך בעת השימוש באתר ו/או
            עם הרשמתך לאחד השירותים המוצעים בו. בכל מקרה, בכל עת תוכל לבטל את
            הסכמתך ובכך למנוע את המשך קבלת המידע. למידע נוסף, אנא פנה לשירותי
            האתר.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>שינויים במדיניות הפרטיות</StyledHeaderH2>
          <StyledBody>
            החברה שומרת לעצמה את הזכות לשנות את מדיניות הפרטיות מעת לעת. במקרה
            שכזה, השינוי יעודכן במסמך זה ויפורסם באתר. שימושך באתר לאחר ביצוע
            השינויים ומתן ההודעה על כך, יעיד על הסכמתך לשינויים אלו, ועל כן אנו
            ממליצים לעיין במדיניות זו מעת לעת.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>זכותך לעיין במידע</StyledHeaderH2>
          <StyledBody>
            {` על-פי חוק הגנת הפרטיות, התשמ"א-1981, הנך, או מי מטעמך, רשאי לעיין
            במידע אודותיך אשר מצוי במאגר החברה ואף לבקש מאתנו לתקן מידע זה אם
            אינו נכון, שלם או מדויק. כדי לממש זכות זו, יש לשלוח בקשה בכתב אל
            החברה לכתובת: ת.ד. 200,אזור התעשייה ניר צבי או פנה לשירותי האתר.`}
          </StyledBody>

          <StyledHeaderH2 $margin={40}>האם האתר מאובטח?</StyledHeaderH2>
          <StyledBody>
            דלק מוטורס עושה כל שביכולתה ונעזרת באמצעי אבטחה טכנולוגיים וארגוניים
            מתקדמים כדי לאבטח את המידע המצוי בשליטתה, כנגד ניצול מקרי או מכוון,
            אובדן, הרס או כנגד גישה על ידי אנשים בלתי מוסמכים או מורשים. על אף
            האמור, החברה אינה יכולה להבטיח את אבטחת המידע ושמירתו באופן מוחלט
            ואינה מתחייבת ששירותיה יהיו חסינים באופן מוחלט מפני גישה בלתי מורשית
            למידע המאוחסן בהם.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>שאלות, בקשות והערות</StyledHeaderH2>
          <StyledBody>
            ניתן לפנות אלינו לבירורים נוספים באמצעות טופס יצירת קשר, או בכתובת
            אזור התעשייה ניר צבי, ת.ד. 200,<br></br>
            באמצעות משלוח פקס למספר 08-9139993<br></br>
            {`בדוא"ל:`}
            <StyledLink
              href="mailto:service1@delekmotors.co.il"
              $color="#4C607E"
            >
              service1@delekmotors.co.il
            </StyledLink>{" "}
            או בטלפון מספר:{" "}
            <StyledLink
              href={"tel:*2880"}
              $color="#4C607E"
              style={{ unicodeBidi: "plaintext" }}
            >
              {" "}
              *2880
            </StyledLink>
          </StyledBody>
        </StyledTextWrapp>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default PrivacyPolicyPage
